import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFormControl } from '../components/base-form-control/Component.js';

var defaultColors = {"inner":"form-control__inner_1vlq2","focused":"form-control__focused_1vlq2","hasError":"form-control__hasError_1vlq2","disabled":"form-control__disabled_1vlq2"};
require('./default.desktop.css')

var styles = {"above":"form-control__above_82ssh","sub":"form-control__sub_82ssh","error":"form-control__error_82ssh","size-40":"form-control__size-40_82ssh","inner":"form-control__inner_82ssh","size-48":"form-control__size-48_82ssh","size-56":"form-control__size-56_82ssh","size-64":"form-control__size-64_82ssh","size-72":"form-control__size-72_82ssh"};
require('./desktop.css')

var invertedColors = {"inner":"form-control__inner_nomul","hasError":"form-control__hasError_nomul","disabled":"form-control__disabled_nomul"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var FormControlDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseFormControl, __assign({}, restProps, { ref: ref, styles: styles, colorStyles: colorStyles }))); });

export { FormControlDesktop };
